// removed by extract-text-webpack-plugin
module.exports = {"LoaderButton":"LoaderButton___aqEpd","spinning":"spinning___3M-Pc","glyphicon":"glyphicon___3aD-n","spin":"spin___27uf_"};


//////////////////
// WEBPACK FOOTER
// ./src/components/LoaderButton.module.less
// module id = 732
// module chunks = 0